import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "form-dialog__title",
  style: {"margin-top":"0"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "开票信息", -1)
const _hoisted_3 = { class: "form-dialog__content" }

import { ref, watchEffect } from 'vue';
import { BaseForm, BaseFormItem, BaseInput, BaseButton } from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import { invoiceInformationEditing } from '@V/invoice/src/data-source/apis';

type BaseInfo = BasicInformationData['baseInfo'];


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-enterprise-dialog-info',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } },
    value: {}
  },
  setup(__props: any) {

const props = __props;

const formRef = ref(null);
const formData = ref<BaseInfo>(props.value);
const disabled = ref(true); // false可编辑并按钮变为保存

const formRules = {
  entpName: [{ required: true, message: '请输入', trigger: 'blur' }],
  entpCertNo: [{ required: true, message: '请输入', trigger: 'blur' }],
  phone: [{ required: true, message: '请输入', trigger: 'blur' }],
  bankName: [{ required: true, message: '请输入', trigger: 'blur' }],
  openBankNumber: [{ required: true, message: '请输入', trigger: 'blur' }],
  companyBusinessAddress: [
    { required: true, message: '请输入', trigger: 'blur' }
  ]
};

watchEffect(() => {
  formData.value = props.value;
});

const onSave = async () => {
  // 保存
  if (!disabled.value) {
    await formRef.value.validate();
    await invoiceInformationEditing(formData.value);
  }
  disabled.value = !disabled.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    model: formData.value,
    rules: formRules
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(BaseButton), {
          size: "small",
          click: onSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(disabled.value ? '编辑' : '保存'), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(BaseFormItem), {
          label: "企业名称",
          prop: "entpName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: formData.value.entpName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.entpName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "纳税识别号",
          prop: "entpCertNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: disabled.value,
              modelValue: formData.value.entpCertNo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.entpCertNo) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "联系电话",
          prop: "phone"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "tel",
              placeholder: "请输入",
              disabled: disabled.value,
              modelValue: formData.value.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.phone) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开户银行",
          prop: "bankName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: disabled.value,
              modelValue: formData.value.bankName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.bankName) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "银行账号",
          prop: "openBankNumber"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: disabled.value,
              modelValue: formData.value.openBankNumber,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.openBankNumber) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "企业地址",
          prop: "companyBusinessAddress"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: disabled.value,
              modelValue: formData.value.companyBusinessAddress,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.companyBusinessAddress) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开票备注",
          prop: "demand"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "textarea",
              placeholder: "请输入",
              "show-word-limit": "",
              disabled: disabled.value,
              rows: 4,
              maxlength: 200,
              modelValue: formData.value.demand,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.demand) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})